module.exports = __webpack_public_path__ + "img/126.7fdb83f2.jpg";